<template>
  <el-container class="iframecontainer">
    <el-header>
      <div class="logo01"><img :src="ossPath + 'logo01.gif'"></div>
      <div class="title">{{title}}</div>
    </el-header>

    <el-main>
      <router-view></router-view>
    </el-main>
  </el-container>
</template>
<script>
  export default{
    components: {
    },
    methods: {
    },
    mounted: function () {
      var _this = this;
      this.title = this.$route.meta.title;
    },
    data(){
      return {
          title: ""
      }
    }
  }
  
</script>
<style scoped>
  body {
    margin: 0;
    padding: 0;
  }
  a {
    cursor: pointer;
    color: blue;
    text-decoration:none;
  }
  a:hover {text-decoration:underline;color:#FF0000}

  .iframecontainer {
    width: 1000px;
    min-height: 100vh;
    margin: 0 auto;
    padding: 0;
    display: flex;
    flex-direction: column;
  }

  .iframecontainer .el-header {
    margin: 0;
    padding: 0;
    height: 60px !important;
    flex-shrink: 0;
  }

  .iframecontainer .el-header .logo01 {
    float: left;
    height: 60px;
    vertical-align: middle;
  }

  .iframecontainer .el-header .logo01 img {
    height: 100%;
  }

  .iframecontainer .el-header .title {
    float: right;
    line-height: 60px;
    color: red;
    font-size: 2em;
  }

  .iframecontainer .el-main {
    flex: 1;
    min-height: 0;
    position: relative;
    padding: 0;
  }

  /* router-view 渲染的子组件根元素撑满 el-main */
  .iframecontainer .el-main > div {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
  }
</style>

<style>
/* 移动端适配 */
@media (max-width: 768px) {
  .iframecontainer {
    /* 用 100% 而不是 100vw：上面 scoped 块里的 body{margin:0} 对 <body> 并不生效
       （body 不在组件模板内，scoped 选择器加不上 data-v 属性），body 仍有 UA 默认
       8px margin，于是 100vw 会连同这 16px 一起溢出，移动端能左右拖动。 */
    width: 100%;
    max-width: 100%;
    margin: 0;
    background-color: #f0f2f5;
  }

  .iframecontainer .el-header {
    height: 48px !important;
    background-color: #fff;
  }

  .iframecontainer .el-header .title {
    font-size: 1.2em;
    line-height: 48px;
  }

  .iframecontainer .el-main {
    padding: 8px;
    background-color: #f0f2f5;
  }
}
</style>
